export default "__VITE_ASSET__CY0rdC7U__"